import type { RefObject } from "preact";
import { useEffect } from "preact/hooks";

interface Props {
    disabled?: boolean;
}

export function useClickOutside<T extends Element>(
    ref: RefObject<T | null | undefined>,
    handler: (e: MouseEvent) => void,
    { disabled = false }: Props = {},
): void {
    useEffect(() => {
        if (disabled) {
            return undefined;
        }

        const onClick = (e: MouseEvent) => {
            const el = ref.current;

            if (el == null || e.composedPath().includes(el)) {
                return;
            }

            handler(e);
        };

        const controller = new AbortController();

        document.addEventListener("click", onClick, {
            capture: true,
            signal: controller.signal,
        });

        return () => controller.abort();
    }, [ref, handler, disabled]);
}
